
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/baseUI/suggestion/suggestion.scss.css.virtualfile';
        module.exports = {"suggestion":"_suggestion_12aj5_1","suggestion__moreButton":"_suggestion__moreButton_12aj5_7","suggestionMoreButton":"_suggestion__moreButton_12aj5_7"};